import React from 'react';
import styled from '@emotion/styled';
import { useTheme } from '../styles/ThemeProvider';

export const ButtonRow = styled.div`
  display: flex;
  align-items: stretch;
  gap: 8px;
  margin-top: 24px;
`;

const GuardrailAlert = styled.div<{ borderColor: string; bgColor: string }>`
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 10px 14px;
  background: ${props => props.bgColor};
  border: 1px solid ${props => props.borderColor};
  border-radius: 8px;
  margin-top: 10px;
  animation: slideIn 0.3s ease;

  @keyframes slideIn {
    from { opacity: 0; transform: translateY(-4px); }
    to   { opacity: 1; transform: translateY(0); }
  }
`;

const GuardrailText = styled.div`
  flex: 1;
`;

const GuardrailCategory = styled.div<{ color: string }>`
  font-size: 12px;
  font-weight: 700;
  color: ${props => props.color};
  text-transform: uppercase;
  letter-spacing: 0.5px;
`;

const GuardrailMessage = styled.div<{ color: string }>`
  font-size: 13px;
  color: ${props => props.color};
  margin-top: 2px;
`;

interface GuardrailAlertBlockProps {
  error: { category: string; message: string };
}

export const GuardrailAlertBlock: React.FC<GuardrailAlertBlockProps> = ({ error }) => {
  const theme = useTheme();
  return (
    <GuardrailAlert borderColor={`${theme.colors.error}50`} bgColor={`${theme.colors.error}08`}>
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke={theme.colors.error} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ flexShrink: 0, marginTop: 1 }}>
        <path d="M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z" />
        <line x1="12" y1="9" x2="12" y2="13" />
        <line x1="12" y1="17" x2="12.01" y2="17" />
      </svg>
      <GuardrailText>
        <GuardrailCategory color={theme.colors.error}>{error.category.replace(/_/g, ' ')}</GuardrailCategory>
        <GuardrailMessage color={theme.colors.textPrimary}>{error.message}</GuardrailMessage>
      </GuardrailText>
    </GuardrailAlert>
  );
};
